<template>
  <section class="bi_main">
    <iframe
      name="BI"
      ref="BIiframe"
      id="BIiframe"
      allowFullScreen="true"
      class="statistics_iframe"
      :src="BiBaseUrl"
      frameborder="0"
    ></iframe>
  </section>
</template>

<script>
import token from "../../utils/token.js";
export default {
  data() {
    return {
      // eslint-disable-next-line no-undef
      BiBaseUrl,
    };
  },
  mounted() {
    let that = this;
    let BIiframe = document.getElementById("BIiframe");
    BIiframe.onload = () => {
      BIiframe.contentWindow.postMessage(
        {
          tokenKey: token.getToken(),
          refreshToken: token.getRefreshToken(),
        },
        "*"
      );
    };
    window.addEventListener("message", function (e) {
      if (e.data.toLogin) {
        that.$router.push("/login");
      }
    });
  },
};
</script>

<style scoped lang="less">
.bi_main {
  height: calc(100vh - 3.5rem - 35px);
  position: absolute;
  right: 0.2rem;
  top: 6rem;
  // overflow: hidden;
}
.statistics_iframe {
  // width: calc(100vw - 16.4rem);
  width: calc(100vw - 15.4rem);
  height: calc(100vh - 3.5rem - 40px);
}
</style>